import React, { Component } from "react";
import Report from "react-powerbi";
import { Container, Row } from "reactstrap";
import ReactLoading from "react-loading";
import api from "../services/api";
import { logout, login } from "../services/auth";
import { obterNovaAutenticacao } from "../services/auth";
import NavBI from "./NavBI";
import { URL } from "../constants/index";
import MediaQuery from "react-responsive";
import { PowerBIEmbed } from "powerbi-client-react";
import { models } from "powerbi-client";
import "./Layout/Dashboard.css";

class Dashboard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      idReport: "",
      embedUrl: "",
      accessToken: "",
      loading: false,
      loadingErro: false,
      menu: [],
      report: null,
    };

    this.myRef = React.createRef();

    this.onLogout = this.onLogout.bind(this);
  }
  onEmbedded(embed) {}

  componentDidMount() {
    this.getDashboard();
    this.startTimerAutenticacao();
    this.startTimerDashboard();

    const menu = [];
    this.setState({ menu: menu });
  }

  componenetUnmout() {
    this.stopTimerDashboard();
    this.stopTimerAutenticacao();
  }

  startTimerDashboard() {
    this.TimerDashboard = setInterval(() => {
      this.getDashboard();
    }, 1800000);
  }

  stopTimerDashboard() {
    clearInterval(this.TimerDashboard);
  }

  startTimerAutenticacao() {
    this.TimerAutenticacao = setInterval(() => {
      this.getNovaAutenticacao();
    }, 900000);
  }

  stopTimerAutenticacao() {
    clearInterval(this.TimerAutenticacao);
  }

  getNovaAutenticacao() {
    const response = obterNovaAutenticacao();

    response.then((res) => {
      login(res.data);
    });
    response.catch((err) => {
      this.onLogout();
    });
  }

  // scrollToMyRef = () => {
  //   console.log(this.myRef);
  //   if (this.myRef.current !== null && this.myRef.current.rootElement != null)
  //     if (this.myRef.current.rootElement.offsetTop !== null) {
  //       console.log(this.myRef.current.rootElement.offsetTop);
  //       window.scrollTo(0, this.myRef.current.rootElement.offsetTop);
  //     }
  // };

  getDashboard = () => {
    this.setState({ loading: true });

    var urlAPIDashboard = "/api/dashboard/" + this.props.URLDashboard;
    api
      .get(urlAPIDashboard)
      .then((res) => {
        this.setState({
          embedUrl: res.data.embedURL,
          idReport: res.data.reportID,
          accessToken: res.data.accessToken,
          loading: false,
          loadingErro: false,
          menu: res.data.listaMenu,
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          loading: false,
          loadingErro: true,
        });
      });
  };

  onLogout() {
    logout()
      .then((res) => this.props.history.push(URL.URLLogin))
      .catch((res) => this.props.history.push(URL.URLLogin));
  }

  setReport = (report) => {
    this.setState({ report: report });
  };

  getFiltros = () => {
    return "";
  };

  render() {
    if (this.state.loading) {
      return (
        <div id="content-bi">
          <NavBI menu={this.state.menu} history={this.props.history} />

          <Container>
            <Row className="justify-content-center">
              <ReactLoading
                type="bubbles"
                color="#343a40"
                height={100}
                width={100}
              />
            </Row>
          </Container>
        </div>
      );
    }

    if (this.state.loadingErro) {
      return (
        <div id="content-bi">
          <NavBI menu={this.state.menu} history={this.props.history} />

          <Container>
            <Row className="justify-content-center">
              <h3>Ocorreu um problema ao carregar dashboard</h3>
            </Row>
          </Container>
        </div>
      );
    }

    return (
      <div id="content-bi">
        <NavBI
          menu={this.state.menu}
          history={this.props.history}
          report={this.state.report}
        />
        <MediaQuery minDeviceWidth={1224}>
          <PowerBIEmbed
            ref={this.myRef}
            embedConfig={{
              type: "report",
              id: this.state.idReport,
              embedUrl: this.state.embedUrl,
              accessToken: this.state.accessToken,
              tokenType: models.TokenType.Aad,

              settings: {
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: {
                    visible: false,
                  },
                },
              },
            }}
            cssClassName={"report-style-class"}
            getEmbeddedComponent={(embedObject) => {
              this.setReport(embedObject);
            }}
          />
        </MediaQuery>

        <MediaQuery maxDeviceWidth={1224}>
          <PowerBIEmbed
            ref={this.myRef}
            embedConfig={{
              type: "report",
              id: this.state.idReport,
              embedUrl: this.state.embedUrl,
              accessToken: this.state.accessToken,
              tokenType: models.TokenType.Aad,
              settings: {
                layoutType: models.LayoutType.MobilePortrait,
                panes: {
                  filters: {
                    expanded: false,
                    visible: false,
                  },
                  pageNavigation: {
                    visible: false,
                  },
                },
              },
              filters: [
                {
                  operator: "In",
                  values: ["OPTVIEW"],
                  $schema: "http://powerbi.com/product/schema#basic",
                  target: {
                    table: "VW_BI_VENDA",
                    column: "Vendedor",
                  },
                  filterType: models.FilterType.Basic,
                },
              ],
            }}
            cssClassName={"report-style-class"}
            getEmbeddedComponent={(embedObject) => {
              this.setReport(embedObject);
            }}
          />
        </MediaQuery>
      </div>
    );
  }
}

export default Dashboard;
